<template>
  <div class="py-4">
    <div class="color-black-1 font-18 font-weight-normal">
      {{ $t('TypeYourNewPassword') }}
    </div>
    <validation-observer ref="formRef" v-slot="{}" tag="form">
      <validation-provider
        name="newPassword"
        rules="required|hasNumberLettersPassword|hasCorrectSizePassword"
        v-slot="{ errors }"
      >
        <custom-form-input
          class="mt-4"
          icon="user-circle"
          v-model="model.newPassword"
          :label="`${$t('lblNewPassword')}:`"
          :type="showNewPasswordInputType"
          :right-icon="showNewPasswordIcon"
          :error="errors[0]"
          :custom-error-msg="errors[0]"
          maxlength="16"
          @on-click-right-icon="onShowNewPasswordHandler"
          v-b-popover.hover="{
            variant: 'warning',
            content: $t('lblPasswordRequired').replace('{0}', '6'),
          }"
        />
      </validation-provider>
      <validation-provider
        rules="required|isEqualToCPassword:@newPassword"
        v-slot="{ errors }"
      >
        <custom-form-input
          class="mt-3"
          icon="user-circle"
          v-model="model.newPasswordConfirm"
          :label="`${$t('ConfirmNewPassword')}:`"
          :type="showNewPasswordConfirmInputType"
          :right-icon="showNewPasswordConfirmIcon"
          :error="errors[0]"
          :custom-error-msg="errors[0]"
          maxlength="16"
          @on-click-right-icon="onShowNewPasswordConfirmHandler"
          v-b-popover.hover="{
            variant: 'warning',
            content: $t('lblPasswordRequired').replace('{0}', '6'),
          }"
        />
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { CustomFormInput } from '@/components/common';
export default {
  name: 'SetNewPassword',
  components: {
    CustomFormInput,
  },
  data: () => ({
    model: {
      newPassword: null,
      newPasswordConfirm: null,
      showNewPassword: false,
      showNewPasswordConfirm: false,
    },
  }),
  computed: {
    showNewPasswordIcon() {
      return `far fa-${this.model.showNewPassword ? 'eye' : 'eye-slash'}`;
    },
    showNewPasswordInputType() {
      return this.model.showNewPassword ? 'text' : 'password';
    },
    showNewPasswordConfirmIcon() {
      return `far fa-${
        this.model.showNewPasswordConfirm ? 'eye' : 'eye-slash'
      }`;
    },
    showNewPasswordConfirmInputType() {
      return this.model.showNewPasswordConfirm ? 'text' : 'password';
    },
  },
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
    onShowNewPasswordHandler() {
      this.model.showNewPassword = !this.model.showNewPassword;
    },
    onShowNewPasswordConfirmHandler() {
      this.model.showNewPasswordConfirm = !this.model.showNewPasswordConfirm;
    },
  },
};
</script>
